<template>
  <CoachShell>

    <div class="bg-gradient-to-r from-purple-300 to-blue-200">
      <div class="m-auto py-16 min-h-screen flex flex-col items-center justify-center">
        <div>
          <!-- Banner? -->
          <div v-if="!isLoggedIn" class="inset-x-0 pb-2 sm:pb-5">
            <div class="max-w-7xl mx-auto px-2 sm:px-6 lg:px-8">
              <div class="p-2 rounded-lg bg-purple-800 shadow-lg sm:p-3">
                <div class="flex items-center justify-between flex-wrap">
                  <div class="w-0 flex-1 flex items-center">
              <span class="flex p-2 rounded-lg bg-purple-600">
                <SpeakerphoneIcon class="h-6 w-6 text-white" aria-hidden="true" />
              </span>
                    <p class="ml-3 font-medium text-white">
                      <span class="">
                        <span class="text-2xl">How to use the App</span><br>
                  You can filter the coaches by Areas of Expertise. <br/> Click on the profile to see Coach's Profile/Details and to message them.
<!--                        <br> You can also register as a Coach.-->
                </span>
                    </p>
                  </div>
  <!--                <div class="order-3 mt-2 flex-shrink-0 w-full sm:order-2 sm:mt-0 sm:w-auto">
                    <a href="#" class="flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-indigo-600 bg-white hover:bg-indigo-50">
                      Learn more
                    </a>
                  </div>-->
<!--                  <div class="order-2 flex-shrink-0 sm:order-3 sm:ml-2">-->
<!--                    <button @click="hideBannner" type="button" class="-mr-1 flex p-2 rounded-md hover:bg-purple-500 focus:outline-none focus:ring-2 focus:ring-white">-->
<!--                      <span class="sr-only">Dismiss</span>-->
<!--                      <XIcon class="h-6 w-6 text-white" aria-hidden="true" />-->
<!--                    </button>-->
<!--                  </div>-->
                </div>
              </div>
            </div>
          </div>

          <div class="relative">
            <div class="max-w-7xl mx-auto lg:bg-transparent lg:px-8">
              <div class="lg:grid lg:grid-cols-12">
                  <div class="relative z-10 lg:col-start-1 lg:row-start-1 lg:col-span-4 lg:py-16 lg:bg-transparent">
                    <div class="absolute inset-x-0 h-1/2 lg:hidden" aria-hidden="true" />
                    <div class="max-w-md mx-auto px-4 sm:max-w-3xl sm:px-6 lg:max-w-none lg:p-0">
                      <div class="aspect-w-10 aspect-h-6 sm:aspect-w-2 sm:aspect-h-1 lg:aspect-w-1">
                        <img class="object-cover object-center rounded-3xl shadow-2xl" src="https://images.unsplash.com/photo-1507207611509-ec012433ff52?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&auto=format&fit=crop&w=934&q=80" alt="" />
                      </div>
                    </div>
                  </div>

                  <div class="relative bg-gray-50 lg:col-start-3 lg:row-start-1 lg:col-span-10 rounded-3xl lg:grid lg:grid-cols-10 lg:items-center">
                    <div class="hidden absolute inset-0 overflow-hidden rounded-3xl lg:block" aria-hidden="true">
                      <svg class="absolute bottom-full left-full transform translate-y-1/3 -translate-x-2/3 xl:bottom-auto xl:top-0 xl:translate-y-0" width="404" height="384" fill="none" viewBox="0 0 404 384" aria-hidden="true">
                        <defs>
                          <pattern id="64e643ad-2176-4f86-b3d7-f2c5da3b6a6d" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
                            <rect x="0" y="0" width="4" height="4" class="text-purple-100" fill="currentColor" />
                          </pattern>
                        </defs>
                        <rect width="404" height="384" fill="url(#64e643ad-2176-4f86-b3d7-f2c5da3b6a6d)" />
                      </svg>
                      <svg class="absolute top-full transform -translate-y-1/3 -translate-x-1/3 xl:-translate-y-1/2" width="404" height="384" fill="none" viewBox="0 0 404 384" aria-hidden="true">
                        <defs>
                          <pattern id="64e643ad-2176-4f86-b3d7-f2c5da3b6a6d" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
                            <rect x="0" y="0" width="4" height="4" class="text-purple-100" fill="currentColor" />
                          </pattern>
                        </defs>
                        <rect width="404" height="384" fill="url(#64e643ad-2176-4f86-b3d7-f2c5da3b6a6d)" />
                      </svg>
                    </div>

                    <div class="relative max-w-md mx-auto py-12 px-4 space-y-6 sm:max-w-3xl sm:py-16 sm:px-6 lg:max-w-none lg:col-start-4 lg:col-span-6">
                      <!--  todo only show if not logged in  -->
                      <div v-if="!isLoggedIn">
                        <div class="divide-y divide-purple-200">
                          <div>
                            <h2 class="text-purple-500">Want to become a Coach?</h2>
                          </div>
                          <div class="py-5">
                          <h2 class="text-6xl font-bold text-purple-400 mb-2">Join our team</h2>
                          <p class="text-lg font-bold text-gray-700">This App allows you to Sign up and then Register as a Coach.</p>
                          <p>Students will be able to search for you based on your areas of expertise and message you if interested. </p>
                          <a class="bg-gradient-to-r from-purple-300 to-blue-200 block w-full py-3 px-5 text-center border border-transparent rounded-md
                          shadow-sm text-base font-medium text-white hover:bg-gray-50 sm:inline-block sm:w-auto mt-5"
                             href="/auth">
                            Login / Register
                          </a>
                        </div>
                        </div>
                      </div>
                      <div v-else>
                        <div v-if="!isCoach">
                          <div class="divide-y divide-purple-200">
                            <div>
                              <h2 class="text-purple-500">What are you waiting for???!!!</h2>
                            </div>
                            <div class="py-5">
                              <h2 class="text-6xl font-bold text-purple-400 mb-2 w-min-full inline-block">Register NOW</h2>
                              <a class="bg-gradient-to-r from-purple-300 to-blue-200 block w-full py-3 px-5 text-center border border-transparent rounded-md
                          shadow-sm text-base font-medium text-white hover:bg-gray-50 sm:inline-block sm:w-auto mt-5"
                                 href="/register">
                                Register as a Coach
                              </a>
                            </div>
                          </div>
                        </div>
                        <div v-else>
                          <div class="divide-y divide-purple-200">
                            <div>
                              <h2 class="text-purple-500">Good to see you again :)</h2>
                            </div>
                            <div class="py-5">
                              <h2 class="text-6xl font-bold text-purple-400 mb-2 w-min-full inline-block">Welcome Back! </h2>
                              <a class="bg-gradient-to-r from-purple-300 to-blue-200 block w-full py-3 px-5 text-center border border-transparent rounded-md
                          shadow-sm text-base font-medium text-white hover:bg-gray-50 sm:inline-block sm:w-auto mt-5"
                                 href="/requests">
                                Check Your Inbox
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
            </div>
          </div>

        </div>
      </div>
    </div>

  </CoachShell>
</template>

<script>
import {
  SpeakerphoneIcon,
  //XIcon ,
} from '@heroicons/vue/outline'
import CoachShell from "./CoachShell";

export default {
  name: "CoachesLanding",
  components: {
    CoachShell,
    SpeakerphoneIcon,
    //XIcon,
  },
  data(){
    return{
      bannerHidden: false,
      loggedIn: false,
    };
  },
  computed: {
    isCoach(){
      return this.$store.getters['coaches/isCoach'];
    },
    isLoggedIn(){
      return this.$store.getters.isAuthenticated;
    },
    // showBanner(){
    //   //console.log(`true or false? ${this.isLoggedIn}`);
    //   console.log(`banner hidden? ${this.bannerHidden}`);
    //   return !this.isLoggedIn;
    // }
  },
  methods: {
    hideBannner(){
      console.log(`banner hidden before click? ${this.bannerHidden}`);
      this.bannerHidden = true;
      console.log(`banner hidden AFTER click? ${this.bannerHidden}`);
    }
  },
}
</script>
